import {Component, Input, OnInit} from '@angular/core';
import {CommonModule, NgClass, NgOptimizedImage} from '@angular/common';
import {BaseSectionComponent} from "../base-section/base-section.component";
import {
  PageTextImagesSection,
  TextImagesDirections,
  TextImagesTypes
} from "../../../models/Page/Sections/PageTextImagesSection";
import {MediaAttachmentComponent} from "../../elements/media-attachment/media-attachment.component";
import {AttachmentFromIdPipe} from "../../../pipes/attachmentFromId/attachment-from-id.pipe";
import {Nl2brPipe} from "../../../pipes/nl2br.pipe";
import {InstagramItemComponent} from "../../elements/instagram-item/instagram-item.component";
import {SafeHtmlPipe} from "../../../pipes/safe-html.pipe";
import {TerreConstrastesSectionComponent} from "../terre-constrastes-section/terre-constrastes-section.component";
import {SynapiListItemsComponent} from "../../elements/synapi-list-items/synapi-list-items.component";

@Component({
  selector: 'text-images-section',
  standalone: true,
  imports: [CommonModule, MediaAttachmentComponent, AttachmentFromIdPipe, BaseSectionComponent, Nl2brPipe, InstagramItemComponent, NgOptimizedImage, SafeHtmlPipe, TerreConstrastesSectionComponent, SynapiListItemsComponent],
  templateUrl: './text-images-section.component.html',
  styleUrl: './text-images-section.component.scss',
  host: {ngSkipHydration: 'true'}
})
export class TextImagesSectionComponent extends BaseSectionComponent<PageTextImagesSection> implements OnInit{
  textImagesTypes = TextImagesTypes;
  textImagesDirections = TextImagesDirections;
  gridClass:any = {};
  colContentClass:any = {};
  colMediaClass:any = {};
  sizeXL : number = 1920
  sizeLG : number = 1200;
  sizeMD : number = 100;
  sizeSM : number = 100;
  sizeXS : number = 100;
  isImage : boolean = false;
  isInstagram : boolean = false;
  isIframe : boolean = false;
  hasSuggestion : boolean = true;
  idsSit: string[] = [];
  scIdsSit: string[] = [];

  override ngOnInit() {
    super.ngOnInit();
    this.setTypeMedia();
    this.setSizes();
    this.setClasses();
    this.setSuggestions();
  }

  setTypeMedia(){
    this.isIframe = this.hasTypes([TextImagesTypes.ONE_IFRAME_1_2,TextImagesTypes.FULL_IFRAME])
    this.isInstagram = this.hasTypes([TextImagesTypes.ONE_INSTRAGRAM_1_2,TextImagesTypes.FULL_INSTAGRAM])
    this.isImage = this.hasTypes([TextImagesTypes.ONE_IMAGE_1_2,TextImagesTypes.TWO_IMAGES_DIAG, TextImagesTypes.TWO_IMAGES_CENTER,TextImagesTypes.ONE_IMAGE_3_5,TextImagesTypes.ONE_IMAGE_4_12, TextImagesTypes.FULL_IMAGE]);
  }

  setClasses(){
    this.gridClass['md-grid-cols-2'] = this.hasTypes([TextImagesTypes.ONE_IMAGE_1_2,TextImagesTypes.ONE_IFRAME_1_2, TextImagesTypes.ONE_INSTRAGRAM_1_2,TextImagesTypes.TWO_IMAGES_DIAG, TextImagesTypes.TWO_IMAGES_CENTER]);
    this.gridClass['md-grid-cols-12'] = this.hasTypes([TextImagesTypes.ONE_IMAGE_4_12]);
    this.gridClass['md-grid-cols-5'] = this.hasTypes([TextImagesTypes.ONE_IMAGE_3_5]);
    this.gridClass['grid-reverse'] = this.sectionRendered.direction == TextImagesDirections.RIGHT;
    this.colContentClass['md-col-span-1'] = this.hasTypes([TextImagesTypes.ONE_IMAGE_1_2,TextImagesTypes.ONE_IFRAME_1_2,TextImagesTypes.TWO_IMAGES_DIAG, TextImagesTypes.TWO_IMAGES_CENTER]);
    this.colContentClass['md-col-span-2'] = this.hasTypes([TextImagesTypes.ONE_IMAGE_3_5]);
    this.colContentClass['md-col-span-8'] = this.hasTypes([TextImagesTypes.ONE_IMAGE_4_12]);
    this.colMediaClass['md-col-span-1'] = this.hasTypes([TextImagesTypes.ONE_IMAGE_1_2]) && this.sectionRendered.content;
    this.colMediaClass['md-col-span-4'] = this.hasTypes([TextImagesTypes.ONE_IMAGE_4_12]) && this.sectionRendered.content;
    this.colMediaClass['md-col-span-3'] = this.hasTypes([TextImagesTypes.ONE_IMAGE_3_5]) && this.sectionRendered.content;
    //this.colMediaClass['md-col-span-12'] = !this.sectionRendered.content;
  }

  hasTypes(types : TextImagesTypes[]){
    return types.find((t)=> t == this.sectionRendered.type) !== undefined;
  }

  setSizes(){
    if(this.sectionRendered.content){
      if(this.sectionRendered.type == TextImagesTypes.ONE_IMAGE_1_2){
        this.sizeXL = 30;
        this.sizeLG = 30;
      }
      if(this.sectionRendered.type == TextImagesTypes.ONE_IMAGE_4_12){
        this.sizeXL = 33;
        this.sizeLG = 33;
      }
      if(this.sectionRendered.type == TextImagesTypes.ONE_IMAGE_3_5){
        this.sizeXL = 30;
        this.sizeLG = 30;
      }
    }
  }

  private setSuggestions() {
    if(this.sectionRendered.selection_sit && !this.sectionRendered.ids_sit){
      this.scIdsSit.push(this.sectionRendered.selection_sit);
      if(this.sectionRendered.filtres_sit){
        this.sectionRendered.filtres_sit.split(',').map((f)=>{
          const filtre = f.trim();
          this.scIdsSit.push(filtre);
        });
      }
    }
    if(this.sectionRendered.ids_sit && !this.sectionRendered.selection_sit){
      this.idsSit = this.sectionRendered.ids_sit.split(',').map((id)=>id.trim());
    }
  }

  onSuggestionTotal($event: number) {
    this.hasSuggestion = $event>0
  }



  protected readonly TextImagesTypes = TextImagesTypes;
  protected readonly TextImagesDirections = TextImagesDirections;


}
